/**
 * 🚨  If you don't know exactly what you're doing, don't ever use this. 🚨
 */
export function dangerouslyInjectHTML(htmlString: string): { __html: string } {
	return { __html: htmlString };
}
